import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { setPageTitle } from "../../../utils/pageTitle";
import { Helmet } from "react-helmet";

class Unauthorized extends Component {
  render() {
    const { t } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>{setPageTitle(["Unauthorized"])}</title>
        </Helmet>
        <header className="layout__title">
          <h2 className="headline-2">
            {t("general.unauthorized.header.name")}
          </h2>
        </header>
        <div className="layout__content">
          <p>{t("general.unauthorized.content")}</p>
        </div>
      </Fragment>
    );
  }
}

export default withTranslation("common")(Unauthorized);
